import React from 'react';
import {withStore} from "../../hocs";
import {observer} from "mobx-react";
import {EnumUserType} from "../../enum/EnumUserType";
import {BreadCrumbs} from "../../components/tpl/BreadCrumbs";
import {RedirectUrl} from "../../components/RedirectUrl";
import { EmptyImageProducts } from '../../components/user/EmptyImageProducts';
import { Button } from '@mui/material';
import ExcelJS from "exceljs";
import {adminPanelUrl} from "../../constants/adminPanelPath";


// @ts-ignore
@withStore
@observer
export class AdminProductWithoutImage extends React.Component {

    componentDidMount() {
        // @ts-ignore
        const {store} = this.props;
        store?.pageAdminProductsWithoutImageStore.init();
        store.basePageStore.setBreadCrumbs([{name: 'Администрирование', url: adminPanelUrl()},{name: 'Таблица товаров без картинок', url: adminPanelUrl('products-without-image')}]).setTitleInBreadCrumbs();
       
    }

    downloadExcelFile = async () => {
        // @ts-ignore
        const {store} = this.props;
        const {arDataProduct} = store?.pageAdminProductsWithoutImageStore;

        if (!arDataProduct || arDataProduct.length === 0) {
            alert('Нет данных для экспорта');
            return;
        }

        try {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Товары без картинок');

            // Заголовки колонок
            worksheet.columns = [
                { header: 'ID', key: 'id', width: 10 },
                { header: 'EX ID', key: 'ex_id', width: 40 },
                { header: 'Наименование', key: 'name', width: 60 },
                { header: 'Код', key: 'code', width: 50 },
                { header: 'Штрих-код', key: 'barcode', width: 20 },
                { header: 'Артикул', key: 'productcode', width: 20 },
                { header: 'Бренд', key: 'brand', width: 20 },
                { header: 'Производитель', key: 'producer', width: 30 },
                { header: 'Количество картинок', key: 'picturesCount', width: 20 },
                { header: 'Ссылка', key: 'link', width: 50 }
            ];

            // Стили для заголовков
            worksheet.getRow(1).font = { bold: true };
            worksheet.getRow(1).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFE0E0E0' }
            };

            // Добавляем данные
            arDataProduct.forEach((item: any, index: number) => {
                const row = worksheet.addRow({
                    id: item.id,
                    ex_id: item.ex_id,
                    name: item.name,
                    code: item.code,
                    barcode: item.barcode,
                    productcode: item.productcode,
                    brand: item.brand,
                    producer: item.producer,
                    picturesCount: item.pictures ? item.pictures.length : 0,
                    link: 'Ссылка'
                });

                // Добавляем гиперссылку к ячейке со ссылкой
                const linkCell = row.getCell('link');
                linkCell.value = {
                    text: 'Ссылка',
                    hyperlink: `https://b2b.sellwin.by/card/${item.code}`
                };
                
                // Стили для ссылки
                linkCell.font = {
                    color: { argb: 'FF0000FF' }, // Синий цвет
                    underline: true
                };
            });

            // Автоподгонка ширины колонок
            worksheet.columns.forEach(column => {
                if (column.values && column.values.length > 1) {
                    const maxLength = Math.max(
                        ...column.values.slice(1).map((value: any) => 
                            value ? value.toString().length : 0
                        )
                    );
                    column.width = Math.min(Math.max(maxLength + 2, 10), 60);
                }
            });

            // Генерируем файл
            const buffer = await workbook.xlsx.writeBuffer();
            
            // Создаем blob и скачиваем файл
            const blob = new Blob([buffer], { 
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
            });
            
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `товары_без_картинок_${new Date().toISOString().split('T')[0]}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Ошибка при создании Excel файла:', error);
            alert('Произошла ошибка при создании файла');
        }
    }

    render() {
        // @ts-ignore
        const {store} = this.props;
        const {
           arDataProduct
        } = store?.pageAdminProductsWithoutImageStore;

        let type = store.mainStore.getUserType();
     
        return (
            <>
                <RedirectUrl/>
                <div className="container">
                    <div className="breadcrumbs">
                        <div className="breadcrumbs-wrapper">
                            <BreadCrumbs/>
                        </div>
                    </div>
                    <div className="catalog-title">
                        <h1 className="catalog-title__text"> Таблица товаров без картинок</h1>
                        <Button 
                            variant='outlined' 
                            color='success'
                            onClick={this.downloadExcelFile}
                            disabled={!arDataProduct || arDataProduct.length === 0}
                        >
                            скачать excel файл
                        </Button>
                    </div>
                    {[EnumUserType.adminAuth, EnumUserType.root].includes(type) ?
                        <EmptyImageProducts
                            arDataProduct={arDataProduct}
                        />
                        : null}
                </div>
            </>
        )
    }
}